import React, { useEffect, useState } from 'react';

const Bar = () => {
  const [scrolledDown, setScrolledDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolledDown(true);
      } else {
        setScrolledDown(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`fixed top-0 left-0 w-full bg-black text-white overflow-hidden z-[1000] text-[18px] font-bold transition-all duration-500 ${scrolledDown ? 'py-2' : 'py-6'}`}>
      <div className="whitespace-nowrap flex gap-[50px]" style={{ animation: 'scroll-left 45s linear infinite' }}>
        <style>
          {`
            @keyframes scroll-left {
              from {
                transform: translateX(100%);
              }
              to {
                transform: translateX(-100%);
              }
            }
          `}
        </style>
        {Array.from({ length: 20 }).map((_, i) => (
          <React.Fragment key={i}>
            <div>doubleyes.store</div>
            <div>doubleyes.pl</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Bar;
